import useFavouriteFeeds from "src/features/FavouriteFeeds/hooks/useFavouriteFeeds";
import { AzureImage } from "src/components/AssetUploaders/AzureImage";

interface HashtagFilterBarProps {
	selectedHashtag: string;
	onHashtagChange: (hashtag: string) => void;
}

const HashtagFilterBar = ({
	selectedHashtag,
	onHashtagChange
}: HashtagFilterBarProps) => {
	const { data: feeds, isLoading } = useFavouriteFeeds();

	if (isLoading || !feeds || feeds.length === 0) return null;

	const selectedFeed = selectedHashtag
		? feeds.find((f) => f.name === selectedHashtag)
		: undefined;

	const pillBase =
		"px-4 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-colors cursor-pointer";
	const selectedClasses = "bg-foreground text-white";
	const unselectedClasses = "bg-subtle text-foreground border border-border";

	return (
		<div>
			<div className="overflow-x-auto scrollbar-hide">
				<div className="flex gap-2 flex-nowrap">
					<button
						type="button"
						aria-current={selectedHashtag === "" ? "page" : undefined}
						className={`${pillBase} ${selectedHashtag === "" ? selectedClasses : unselectedClasses}`}
						onClick={() => onHashtagChange("")}
					>
						All
					</button>
					{feeds.map((feed) => (
						<button
							key={feed.uuid}
							type="button"
							aria-current={selectedHashtag === feed.name ? "page" : undefined}
							className={`${pillBase} ${selectedHashtag === feed.name ? selectedClasses : unselectedClasses}`}
							onClick={() => onHashtagChange(feed.name)}
						>
							#{feed.name}
						</button>
					))}
				</div>
			</div>
			{selectedFeed && (selectedFeed.image || selectedFeed.description) && (
				<div className="mt-3 rounded-xl overflow-hidden border border-border">
					{selectedFeed.image && (
						<AzureImage
							uuid={selectedFeed.image}
							imageProfile="retail-app-social-image"
							alt={selectedFeed.name}
							style={{ width: "100%", height: 160, objectFit: "cover" }}
						/>
					)}
					{selectedFeed.description && (
						<div className="px-4 py-3 bg-white">
							<p className="text-sm text-muted-foreground">
								{selectedFeed.description}
							</p>
						</div>
					)}
				</div>
			)}
		</div>
	);
};

export default HashtagFilterBar;
